import styled from "styled-components";
import {Div} from "atomize";
import theme from "./../../../Theme/Theme";

const GrayBg = styled(Div)`
  background-color: ${theme.colors.alphaPrimary};
  // background-image: ${theme.colors.alphaPrimaryGradient} ;
  //background-color: rgba(0, 155, 223, 0.42);
`;

export default GrayBg;
